import { Subscription } from 'rxjs';

export abstract class DragDisableHandler {

  isDragDisabled: boolean;
  subscription: Subscription;

  disableDragging() {
    this.isDragDisabled = true;
  }

  enableDragging() {
    this.isDragDisabled = false;
  }
}
